/**
 * Regular expression to check if the user is on a Shopify product page
 *
 * Example URL Paths:
 * /collections/example-collection/products/example-item-name
 * /products/item-name-example
 */
const PRODUCT_PAGE_REGEX = /\/products\/\S+$/;

/**
 * The regular expression to check if the user is on the Shopify purchase confirmation page.
 *
 * Example URL Path:
 * /27504377961/checkouts/07f4915c833b22b12590549653902566/thank_you
 */
const PURCHASE_CONFIRMATION_PAGE_REGEX = /^\/[0-9]+\/checkouts\/[A-z0-9]+\/thank_you/g;

/**
 * Utility method to determine if the user is currently on the purchase confirmation page.
 */
export function isOnPurchaseConfirmationPage(): boolean {
  return PURCHASE_CONFIRMATION_PAGE_REGEX.test(window.location.pathname);
}

/**
 * Utility method to determine if the user is currently on a password protected store page.
 */
export function isOnPasswordProtectedPage(): boolean {
  return window.location.pathname === '/password';
}

/**
 * Utility method to determine if the user is currently on the product page
 */
export function isOnProductPage(): boolean {
  return PRODUCT_PAGE_REGEX.test(window.location.pathname);
}

/**
 * Utility to retrieve the URL slug on a product page.
 * The slug contains the product handle, that can be
 * used to fetch product information.
 */
export function getProductUrlSlug(): string | undefined {
  if (!isOnProductPage()) {
    return undefined;
  }

  const slugIndexPosition: number = window.location.pathname.lastIndexOf('/') + 1;
  return window.location.pathname.substring(slugIndexPosition);
}

/**
 * Utility that retrieves the variant Id if it is present
 * on the shop url.
 *
 * The variant id will be used to determine out of stock status for
 * individual variants on a single product.
 */
export function getProductVariant(): string | null {
  const currentUrl = new URL(window.location.href)
  const searchParams: URLSearchParams = currentUrl.searchParams;

  return searchParams.get('variant');
}
